import React, { PureComponent } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { withStyles } from 'tss-react/mui';
import { DateRange } from '@mui/icons-material';
import Zoom from '@mui/material/Zoom';
import Drawer from '@mui/material/SwipeableDrawer';
import 'react-day-picker/dist/style.css';
import { dayjs } from '@lba-dev/package.local-globals/dayjs';
import { modes } from '@lba-dev/package.local-globals/stats';

import DatePicker from '../../../DatePicker';
import styles from '../../../../utils/stylesStatsPanel';


const MODE_ADAPTER = {
  day: 'jour',
  week: 'semaine',
  month: 'mois',
  year: 'année',
  years: 'années',
};

const modifiersStyles = {
  selected: {
    color: '#4a90e2',
    backgroundColor: '#f0f8ff',
  },
};

const defaultEnabledModes = [true, true, true, true, false];

class StatsPanel extends PureComponent {
  enabledModes = this.props.enabledModes || defaultEnabledModes;

  futures = [];

  range = this.props.range || [true, false, false, false, true];
  mode = (this.props.defaultState && this.props.defaultState.mode) || 'day';
  defaultState = this.props.defaultState;

  state = {
    mode: this.mode,
    hover: false,
    panel: [
      { id: 0,
        title: 'Date de départ',
        display: true,
        open: false,
        from:
          (this.defaultState?.from) ||
          dayjs().startOf('day').toDate(),
        to:
          (this.defaultState?.to) ||
          dayjs().endOf('day').toDate()
      },
      { id: 1,
        title: 'Date de fin',
        display: this.props.multiDates,
        open: false,
        from: dayjs().startOf('day').toDate(),
        to: dayjs().endOf('day').toDate()
      }
    ]
  };

  componentDidMount() {
    window.addEventListener('click', this.closePanel);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.defaultState.mode !== this.props.defaultState.mode) {
      this.setState({
        mode: this.props.defaultState.mode
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.closePanel);
  }

  toggleModePanel = (open) => {
    this.futures.forEach((future) => clearTimeout(future));
    this.setState({ hover: open });
  };

  selectMode = (mode) => {
    const { onDatesChange, multiDates } = this.props;
    const { panel } = this.state;
    const initialDates = this.getInitialState(mode);
    if (typeof onDatesChange === 'function' && multiDates) {
      onDatesChange(panel, mode);
    } else if (typeof onDatesChange === 'function') {
      onDatesChange(initialDates.from, initialDates.to, mode);
    }

    this.setState((prevState) => {
      const { multiDates } = this.props;
      const panel = [ ...prevState.panel ];
      const initialFrom = this.getInitialState(mode, panel[0].from);
      const compareFrom = this.getInitialState(mode, panel[0].from, 1);
      panel.forEach((panel, i) => {
        if (i === 0 && multiDates) {
          panel.from = initialFrom.from;
          panel.to = initialFrom.to;
        } else if (i === 1 && multiDates) {
          panel.from = compareFrom.from;
          panel.to = compareFrom.to;
        } else {
          panel.from = initialDates.from;
          panel.to = initialDates.to;
        }
        return panel;
      });
      return { panel, mode };
    });
  };

  UNSAFE_componentWillReceiveProps(props) {
    if (
      props.enabledModes &&
      !props.enabledModes.every((v, i) => v === this.enabledModes[i])
    ) {
      this.enabledModes = props.enabledModes;
    } else if (!props.enabledModes) {
      this.enabledModes = defaultEnabledModes;
    }
    if (props.multiDates !== this.props.multiDates) {
      const panel = [...this.state.panel];
      panel[1].display = props.multiDates;
      this.setState({ panel });
    }
  }

  generateModePanel = () => {
    const { classes } = this.props;
    const { mode, hover, panel } = this.state;
    const panelIsOpen = panel.some(e => e.open === true);
    const condition = (m) => m === mode || hover || panelIsOpen;
    return (
      <div
        className={classes.flex}
        onMouseEnter={() => this.toggleModePanel(true)}
        onMouseLeave={() =>
          this.futures.push(setTimeout(() => this.toggleModePanel(false), 3000))
        }
      >
        <div className={classes.verticalAlign}>
          <div className={classes.verticalAlignItem}>
            <div>
              {!hover && !panelIsOpen ? (
                <span>&#x2039;</span>
              ) : (
                <span>&#x203A;</span>
              )}
            </div>
          </div>
        </div>
        {Object.keys(modes)
          .filter((m, i) => this.enabledModes[i])
          .map((m, i) => (
            <Zoom
              key={m}
              in={condition(m)}
              {...(condition(m) ? { timeout: (i + 1) * 300 } : {})}
            >
              <Button
                className={classes.button}
                color={m === mode ? 'primary' : 'inherit'}
                style={{
                  display: condition(m) ? 'block' : 'none',
                  position: condition(m) ? 'relative' : 'absolute',
                }}
                onClick={() => this.selectMode(m)}
              >
                {MODE_ADAPTER[m]}
              </Button>
            </Zoom>
          ))}
      </div>
    );
  };

  getInitialState = (mode, start = null, add = 0) => ({
    from:
    mode !== 'years'
      ? dayjs(start || new Date()).startOf(mode).add(add, mode).toDate()
      : dayjs(start || new Date()).year(2019).startOf(mode)
        .add(add, mode).toDate(),
    to: dayjs(start || new Date()).endOf(mode).add(add, mode).toDate(),
  });

  handleDayClick = (day, i) => {
    const { mode } = this.state;
    const { multiDates, onDatesChange } = this.props;
    const rangeEnabled =
      mode !== 'day' &&
      Object.keys(modes).filter((m, i) => m === mode && this.range[i]).length;
    const range = {};
    range.from = dayjs(rangeEnabled ? day : day)
      .startOf(mode)
      .toDate();
    range.to = dayjs(rangeEnabled ? day : day)
      .endOf(mode)
      .toDate();

    if (onDatesChange && !multiDates) {
      this.props.onDatesChange(range.from, range.to, mode);
    }

    this.setState(prevState => {
      const panel = [ ...prevState.panel ];
      panel[i].from = range.from;
      panel[i].to = range.to;
      const fromDate = this.getInitialState(mode, panel[0].from, 1);
      const toDate = this.getInitialState(mode, panel[0].to, 1);
      if (i === 0 && multiDates) {
        panel[1].from = fromDate.from;
        panel[1].to = mode === 'day' ? fromDate.to : toDate.to;
      }
      if (onDatesChange && multiDates) {
        this.props.onDatesChange(panel, mode);
      }
      panel.forEach((p) => {
        p.open = false;
      });
      return { panel };
    });
  };

  generateText(from, to, mode, range) {
    let text = '';

    range = range[Object.keys(modes).indexOf(mode)];

    if ((range && !isNaN(to.getTime())) || mode !== 'day') {
      if (!from || isNaN(from.getTime())) {
        text = `Dates sélectionnés: ${to.toLocaleDateString('fr')}`;
      } else {
        text = `Dates sélectionnés du ${from.toLocaleDateString(
          'fr'
        )} au ${to.toLocaleDateString('fr')}`;
      }
    } else if (!range) {
      text = `Dates sélectionnés: ${from.toLocaleDateString('fr')}`;
    } else {
      text = 'Aucune date selectionné';
    }
    return (
      <p style={{ textAlign: 'center' }}>
        {text}
        <b />
      </p>
    );
  }

  openPanel = (e, i) => {
    e.stopPropagation();
    this.setState(prevState => {
      const panel = [ ...prevState.panel ];
      panel.forEach(panel => {
        if (panel.id !== i) {
          panel.open = false;
          return;
        }
        panel.open = !panel.open;
      });
      return { panel };
    });
  }

  closePanel = () => {
    this.setState(prevState => {
      const panel = [ ...prevState.panel ];
      panel.forEach(panel => {
        panel.open = false;
        return panel;
      });
      return { panel };
    });
  }

  render() {
    const {
      classes,
      title,
      body,
      children,
      loading,
      subTitle,
      hideMenu,
      displayModePanel,
      displayDatesDropper,
      MainComponent = 'div',
      titleProps,
      multiDates
    } = this.props;
    const { mode, panel } = this.state;
    return (
      <MainComponent className={classes.root}>
        <div className={classes.container}>
          <div style={{ width: hideMenu ? '100%' : '' }}>
            <Typography
              component="h3"
              variant="h6"
              className={classes.title}
              {...titleProps}>
              {title}
            </Typography>
            {subTitle &&
              <Typography variant="body1" className={classes.subTitle}>
                {subTitle}
              </Typography>}
          </div>
          {body}
          {!hideMenu && <div className={classes.rightMenu}>
            {displayModePanel && this.generateModePanel()}
            {displayModePanel && displayDatesDropper && (
              <div className={classes.divider} />
            )}
            {displayDatesDropper && panel.map((e, i) => e.display && (
              <DateRange
                key={`${e.title}-${e.to}`}
                style={{ color: !e.open ? 'grey' : '#2196f3' }}
                onClick={(e) => this.openPanel(e, i)}
                className={classes.dateSettings}
              />
            )) }
          </div>}
        </div>
        {panel.map((e, i) => e.display && e.open && (
          <div
            key={`${e.title}-${e.id}`}
            className={classes.datesPanel}
            style={e.open ? {} : { ...styles.displayNone }}
          >
            <Drawer
              variant="persistent"
              anchor={'right'}
              open={e.open}
              onOpen={(e) => e}
              onClose={() => this.closePanel()}
              classes={{
                paper: classes.drawerPaper,
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Paper className={classes.drawerHeader}>
                {multiDates && <p
                  style={{ textAlign: 'center', fontWeight: 'bold' }}
                >
                  {e.title}
                </p>}
                {this.generateText(e.from, e.to, mode, this.range)}
                <DatePicker
                  numberOfMonths={2}
                  selected={{ from: e.from, to: e.to }}
                  onChange={(day) => this.handleDayClick(day, i)}
                  modifiers={{ start: e.from, end: e.to }}
                  modifiersStyles={mode !== 'day' ? modifiersStyles : {}}
                  showWeekNumbers
                  fixedWeeks={mode !== 'month'}
                  disabledDays={multiDates ? [
                    { before: i !== 0 &&
                    dayjs(panel[0].to).add(1, 'day').toDate() }
                  ] : []}
                />
              </Paper>
            </Drawer>
          </div>))}
        {loading ? (
          <div className={classes.loadingDiv}>
            <CircularProgress size={50} />
          </div>
        ) :
          children
        }
      </MainComponent>
    );
  }
}

StatsPanel.defaultProps = {
  displayModePanel: true,
  displayDatesDropper: true,
};

export default withStyles(StatsPanel, styles);
